"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = '.radiogroup__elem{padding:2px;transition:box-shadow .2s ease}.radiogroup__elem.form-error{box-shadow:inset 0px 0px 0 1px var(--error);border-radius:2px}';